import { Outlet } from 'react-router-dom';

import SnackBar from '@lib/core/src/components/SnackBar';
import { SnackbarProvider } from 'notistack';

import LoginContextProvider from '@/context/LoginFlowContextProvider/LoginContextProvider';
import { MeetingAnalyzeContextProvider } from '@/context/MeetingAnalyzeContextProvider/MeetingAnalyzeContextProvider';
import { RAW_ROUTES } from '@/enums/RoutesMap';
import useRouteChangeDetection from '@/hooks/useRouteChangeDetection';
import { useVersionChecker } from '@/hooks/useVersionChecker';
import { MeetingHubFiltersProvider } from '@/pages/meetingsHub/MeetingHubFiltersContext';
import { useChatActions } from '@/store/chat/chatStore';

import ModalProvider from './ModalProvider/ModalProvider';
import PostHogBridge from './PostHog/PostHogBridge';

const Providers = () => {
  const { resetChat } = useChatActions();
  useVersionChecker();
  useRouteChangeDetection(RAW_ROUTES.Chat, () => {
    resetChat();
  });

  return (
    <SnackbarProvider
      maxSnack={1}
      Components={{
        custom: SnackBar
      }}
    >
      <LoginContextProvider>
        <PostHogBridge />
        <MeetingAnalyzeContextProvider>
          <MeetingHubFiltersProvider>
            <ModalProvider>
              <Outlet />
            </ModalProvider>
          </MeetingHubFiltersProvider>
        </MeetingAnalyzeContextProvider>
      </LoginContextProvider>
    </SnackbarProvider>
  );
};

export default Providers;
